/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationUserSessionIssuersList } from "../funcs/organizationUserSessionIssuersList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListOrganizationUserSessionIssuersRequest,
  ListOrganizationUserSessionIssuersResponse,
  ListOrganizationUserSessionIssuersSecurity,
  QueryParamTier,
} from "../models/operations/listorganizationusersessionissuers.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type OrganizationUserSessionIssuersQueryData =
  ListOrganizationUserSessionIssuersResponse;

export type OrganizationUserSessionIssuersInfiniteQueryData = PageIterator<
  ListOrganizationUserSessionIssuersResponse,
  { cursor: string }
>;

export type OrganizationUserSessionIssuersPageParams = PageIterator<
  ListOrganizationUserSessionIssuersResponse,
  { cursor: string }
>["~next"];

export function prefetchOrganizationUserSessionIssuers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListOrganizationUserSessionIssuersRequest | undefined,
  security?: ListOrganizationUserSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationUserSessionIssuersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchOrganizationUserSessionIssuersInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListOrganizationUserSessionIssuersRequest | undefined,
  security?: ListOrganizationUserSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildOrganizationUserSessionIssuersInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as OrganizationUserSessionIssuersPageParams,
    getNextPageParam: (
      previousPage: OrganizationUserSessionIssuersInfiniteQueryData,
    ) => previousPage["~next"],
  });
}

export function buildOrganizationUserSessionIssuersQuery(
  client$: GramCore,
  request?: ListOrganizationUserSessionIssuersRequest | undefined,
  security?: ListOrganizationUserSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationUserSessionIssuersQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationUserSessionIssuers({
      cursor: request?.cursor,
      limit: request?.limit,
      tier: request?.tier,
      gramSession: request?.gramSession,
    }),
    queryFn: async function organizationUserSessionIssuersQueryFn(
      ctx,
    ): Promise<OrganizationUserSessionIssuersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationUserSessionIssuersList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildOrganizationUserSessionIssuersInfiniteQuery(
  client$: GramCore,
  request?: ListOrganizationUserSessionIssuersRequest | undefined,
  security?: ListOrganizationUserSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<
      QueryKey,
      OrganizationUserSessionIssuersPageParams
    >,
  ) => Promise<OrganizationUserSessionIssuersInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationUserSessionIssuersInfinite({
      cursor: request?.cursor,
      limit: request?.limit,
      tier: request?.tier,
      gramSession: request?.gramSession,
    }),
    queryFn: async function organizationUserSessionIssuersQuery(
      ctx,
    ): Promise<OrganizationUserSessionIssuersInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(
          organizationUserSessionIssuersList(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(
        organizationUserSessionIssuersList(
          client$,
          {
            ...request!,
            cursor: ctx.pageParam.cursor,
          },
          security,
          mergedOptions,
        ),
      );
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyOrganizationUserSessionIssuers(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    tier?: QueryParamTier | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "organizationUserSessionIssuers", "list", parameters];
}

export function queryKeyOrganizationUserSessionIssuersInfinite(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    tier?: QueryParamTier | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationUserSessionIssuers",
    "list",
    "infinite",
    parameters,
  ];
}
